import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import DemographicPromptResponseModel from "../../../Account/Models/DemographicPromptResponseModel";
import { deepCopy } from "../../Utility/DeepCopy";
import { abpnClient } from "../../../../Services/AbpnClient";
import { AuthContext } from "../../../Auth/AuthProvider";
import Physician from "../../../Physician/Models/Physician";

interface IProps {
    physician : Physician;
    setShowDemographicsModal: Function;
    showDemographicsModal: boolean;
}

export default function DemographicsNotification(props : IProps) {

    const history = useHistory();
    const authContext = useContext(AuthContext);


    const onPrimaryActionTaken = () =>{
        history.push('/AccountInformation');

    }
    
    return (<>
        {props.showDemographicsModal && <Modal
            show={props.showDemographicsModal}
            backdrop="static"
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            keyboard={false}>
            <Modal.Header>
                <Modal.Title>ABPN Demographic Survey</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    The American Board of Psychiatry and Neurology (ABPN) and its Board of Directors are committed to ensuring that ABPN programs and services are equally available to all. The survey asks for information on race, ethnicity, and gender.
                </p>
                <p>
                    Survey results will have no bearing on a physician’s certification status. The ABPN will not share data that could be used to identify individual trainees, training programs, applicants, candidates, or diplomates.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="pp-primary" onClick={onPrimaryActionTaken}>Proceed to Demographic Survey</Button>
            </Modal.Footer>
        </Modal>}
        </>);
}